'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcDelete,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  Typography,
} from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { track } from '@musinsa/packages-event-snowplow';
import { usePreventBodyScroll } from '../../common/hooks/usePreventBodyScroll';
import type { MonthOptionType } from '../../me/sections/SalesRankingFilterSection/SalesRankingMonthSelector/utils';
import { SNOWPLOW_SCHEME } from '../../snowplow';

interface DatePeriodBottomSheetProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  availableMonths: MonthOptionType[];
  selectedMonth?: MonthOptionType;
  onPeriodSelect: (month: MonthOptionType) => void;
}

export const DatePeriodBottomSheet = ({
  isOpen,
  onOpenChange,
  availableMonths,
  selectedMonth,
  onPeriodSelect,
}: DatePeriodBottomSheetProps) => {
  const { service } = useDeviceInfo();
  // 바텀시트 열렸을 때 뒤쪽 스크롤 방지
  usePreventBodyScroll({ open: isOpen });

  const handlePeriodSelect = (month: MonthOptionType) => {
    if (service === SERVICE['29CM']) {
      track({
        schema: SNOWPLOW_SCHEME.CLICK_BUTTON,
        data: {
          page_name: 'curator_monthly_revenue',
          section_name: 'CuratorMonthlyRevenue',
          section_title: 'CuratorMonthlyRevenue',
          position: -1,
          button_id: 'tag',
          button_name: month.label ?? '',
        },
      });
    }
    onPeriodSelect(month);
    onOpenChange(false);
  };

  return (
    <Sheet direction="bottom" open={isOpen} onOpenChange={onOpenChange}>
      <SheetPortal>
        <SheetContent onPointerDownOutside={() => onOpenChange(false)}>
          <SheetMotion direction="bottom">
            <div className="max-h-[548px] flex flex-col min-h-[0]">
              <BottomSheetTitle className="shrink-0">
                <BottomSheetHandleArea />
                <BottomSheetTitleContainer>
                  <BottomSheetTitleBox>기간 선택</BottomSheetTitleBox>
                  <IconButton size="size28x28" onClick={() => onOpenChange(false)}>
                    <IcDelete />
                  </IconButton>
                </BottomSheetTitleContainer>
              </BottomSheetTitle>
              <div className="flex flex-col px-4 bg-white pb-[12px]! safe-area-bottom text-left grow overflow-y-auto min-h-[0]">
                {availableMonths.map((month) => (
                  <Typography
                    key={`${month.label}`}
                    onClick={() => handlePeriodSelect(month)}
                    colorScheme={
                      selectedMonth &&
                      month.year === selectedMonth.year &&
                      month.month === selectedMonth.month
                        ? 'black'
                        : 'gray-600'
                    }
                    variant={
                      selectedMonth &&
                      month.year === selectedMonth.year &&
                      month.month === selectedMonth.month
                        ? 'body13pxSemi'
                        : 'body13pxReg'
                    }
                    className="py-3 cursor-pointer"
                  >
                    {month.label ?? ''}
                  </Typography>
                ))}
              </div>
            </div>
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
};
